exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odot-logo {\n\twidth: 180px;\n\tmargin-left: 10px;\n}\n.logo-size {\n\theight: 100px;\n}\n\n.version {\n\tposition: absolute;\n\tbottom: 10px;\n\tleft: 16px;\n\tcolor: #ddd;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/sidebar/sidebar.component.css
// module id = ../../../../../src/app/sidebar/sidebar.component.css
// module chunks = main